export const AUTH_SESSION_EXPIRED_EVENT = "attrio:auth-session-expired";
export const AUTH_SESSION_EXPIRED_MESSAGE_KEY = "attrio:auth-session-expired-message";
export const DEFAULT_SESSION_EXPIRED_MESSAGE = "Your session expired. Please sign in again.";

export type AuthSessionExpiredDetail = {
  message?: string;
  returnTo?: string;
  source?: "api" | "realtime";
};

function getCurrentReturnPath(): string {
  if (typeof window === "undefined") return "/dashboard";
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function notifyAuthSessionExpired(detail: AuthSessionExpiredDetail = {}): void {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent<AuthSessionExpiredDetail>(AUTH_SESSION_EXPIRED_EVENT, {
      detail: {
        message: detail.message || DEFAULT_SESSION_EXPIRED_MESSAGE,
        returnTo: detail.returnTo || getCurrentReturnPath(),
        source: detail.source,
      },
    }),
  );
}

export function getSafeInternalReturnTo(value: string | null | undefined): string {
  if (!value) return "/dashboard";
  return value.startsWith("/") && !value.startsWith("//") ? value : "/dashboard";
}
